import { LeftProps } from "./types";
import * as S from "./styles";

const Left = (props: LeftProps) => {
  return <S.Left>{props.children}</S.Left>;
};

export default Left;
